import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@material-ui/core";
import React from "react";
import { IOption } from "../../models/IOption";

interface IReadOnlyRadioOptionProps {
  label: string;
  option: IOption;
}

const ReadOnlyRadioOption = (props: IReadOnlyRadioOptionProps) => {
  const { label, option } = props;

  const getLabel = (opt: IOption) => {
    return opt.Price ? `${opt.Description} ($${opt.Price})` : opt.Description;
  };

  return (
    <FormControl
      component="fieldset"
      style={{
        display: "block",
        marginTop: "10px",
        marginBottom: "20px",
      }}
    >
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup>
        <FormControlLabel key={option.Key} control={<Radio key={option.Key} checked={true} value={option.Key} />} label={getLabel(option)} />
      </RadioGroup>
    </FormControl>
  );
};

export default ReadOnlyRadioOption;
